import { PlanogramLayout } from "../models/layout/planogram-layout";
import { ProductOverride } from "../models/product-override";
import { ProductReference } from "../models/layout/product-reference";
import { PlanogramLevel } from "../models/planogram-level";
import { SerializedPlanogramLayout } from "../models/serialized-planogram-layout";

export class SavePlanogramStateRequest{
    planogramId : string = '';
    stateId : string | null = null;
    newSave: boolean = false;
    name : string | null = null;
    levels : PlanogramLevel[];
    overrides : ProductOverride[];
    settings : any = {};
    layout?: SerializedPlanogramLayout | null = null;

    constructor(
        planogramId: string,
        stateId : string | null,
        newSave: boolean,
        name : string | null,
        levels: PlanogramLevel[],
        overrides: ProductOverride[],
        settings: any = {},
        layout?: PlanogramLayout | null
    ){
        this.planogramId = planogramId;
        this.stateId = stateId;
        this.newSave = newSave;
        this.name = name;
        this.levels = levels;
        this.overrides = overrides;
        this.settings = settings;
        if(layout){
            // Convert the Map to a regular object for serialization
            const serializedProductReference: { [key: number]: ProductReference } = {};
            layout.productReference.forEach((value, key) => {
                serializedProductReference[key] = value;
            });

            this.layout = {
                ...layout,
                productReference: serializedProductReference
            };
        }
    }
}

